<mat-dialog-content *ngIf="storageTypes as storageTypes">

  <!-- Destination Dropdown -->
  <mat-form-field class="form-field" color="accent" id="form-field-destination">
    <mat-label>Destination</mat-label>
    <mat-select [(ngModel)]="storageTypeId">
      <mat-option *ngFor="let storageType of storageTypes" [value]="storageType.id">
        {{storageType.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- HttpData Options Section -->
  <div class="rest-api-options" *ngIf="isProxyPath || isProxyQueryParams">
    <h4>HttpData Source Options</h4>

    <!-- Proxy URL Path (Optional) -->
    <mat-form-field *ngIf="isProxyPath" class="form-field" color="accent" id="form-field-proxy-url">
      <mat-label>Proxy URL Path (Optional)</mat-label>
      <input matInput [(ngModel)]="proxyUrlPath" placeholder="Enter proxy URL path">
    </mat-form-field>

    <!-- Proxy Query Params (Optional Key-Value Pairs) -->
    <div *ngIf="isProxyQueryParams">
      <h5>Proxy Query Params (Optional)</h5>

      <div *ngFor="let param of proxyQueryParams; let i = index" class="query-param-row">
        <mat-form-field class="form-field">
          <mat-label>Key</mat-label>
          <input matInput [(ngModel)]="param.key" placeholder="Enter key">
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label>Value</mat-label>
          <input matInput [(ngModel)]="param.value" placeholder="Enter value">
        </mat-form-field>
        <button mat-icon-button color="warn" (click)="removeQueryParam(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <button mat-stroked-button color="primary" (click)="addQueryParam()">
        <mat-icon>add</mat-icon> Add Query Param
      </button>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <div>
    <button (click)="onTransfer()" color="accent" mat-stroked-button [disabled]="!storageTypeId || storageTypeId === ''">
      <mat-icon>downloading</mat-icon> Start transfer
    </button>

    <button color="accent" mat-dialog-close mat-stroked-button>
      <mat-icon>cancel</mat-icon> Cancel
    </button>
  </div>
  <!-- <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar> -->
</mat-dialog-actions>
